<template>
  <v-container>
    <v-row v-if="error" >
      <v-col cols="12" sm="6">
        <app-alert @dismissed="onDismissed" :title="error.title" :text="error.message"></app-alert>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <div class="headline mb-4 text-center">Registration Form</div>
        <v-card>
          <v-container>
            <v-card-text>
              <v-form id="registration-form" ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="firstName"
                      :rules="[rules.required]"
                      label="First name *"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                    v-model="lastName"
                    :rules="[rules.required]"
                    label="Last name *"
                    required
                  ></v-text-field>
                  </v-col>
                </v-row>
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.emailValid]"
                  label="E-mail *"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :rules="[rules.required, rules.min]"
                  :type="'password'"
                  name="password"
                  label="Password *"
                  hint="At least 8 characters"
                  counter
                ></v-text-field>
                <p>Make sure to read our <a href="https://divorceanswered.com.au/terms-of-use/" target="_blank">Terms of Use</a> and <a href="https://divorceanswered.com.au/privacypolicy/" target="_blank">Privacy Policy</a></p>
                <v-checkbox
                  v-model="agreed"
                  :rules="[rules.agree]"
                  label="I agree to the Terms and Conditions and Privacy Policy"
                  required
                ></v-checkbox>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="submit"
                :disabled="loading"
                :loading="loading"
                form="registration-form"
                >
                submit
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <div class="subheading mt-4 text-center">Already have an account? <v-btn outlined :to="'/login'">Log in</v-btn></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      rules: {
        required: v => !!v || 'Required.',
        agree: v => !!v || 'You must agree to continue!',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailValid: v => /.+@.+/.test(v) || 'E-mail must be valid'
      },
      organisation: '',
      firstName: '',
      lastName: '',
      email: '',
      agreed: false,
      password: '',
      confirmPassword: ''
    }
  },
  mounted () {
    this.$store.dispatch('clearError')
  },
  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signup', {
          organisation: this.organisation,
          agreed: this.agreed,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password
        })
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
